import React, { Component } from 'react'
import LoadingOverlay from 'react-loading-overlay';
import { SpinnerCircular } from 'spinners-react';

export default class Loader extends Component {
    render() {
        return (
            <React.Fragment>
                <div className='lodar-box-sec' style={{
                    position: "fixed",
                    zIndex: "999",
                    left: "0",
                    top: " 0",
                    width: " 100%",
                    height: " 100%",
                    overflow: "auto",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    padding: "210px",

                }}>
                    <LoadingOverlay
                        active={true}
                        spinner={<SpinnerCircular color={'rgba(230,46,45,0.6)'} />}
                    >
                    </LoadingOverlay>
                </div>
            </React.Fragment>
        )
    }
}
